import styled from "styled-components"
import {Grid} from "react-bootstrap"

import {minWidthMedia} from "@irati/ui/src/global/media"

const PaddingGrid = styled(Grid)`
  padding-top: 30px;
  ${minWidthMedia.desktop`
    padding-top: 60px;
  `}
  ${minWidthMedia.largeDesktop`
    padding: 60px;
  `}
`

export default PaddingGrid
